import {
  AuthStepDefinition,
  AuthStepsRegistry,
} from '../models/auth-flow.models';
import { CONFIRM_EMAIL_STEP } from './confirm-email-step/confirm-email-step.config';
import { ENTER_EMAIL_STEP } from './enter-email-step/enter-email-step.config';
import { ONBOARDING_STEP } from './onboarding-step/onboarding-step.config';
import { PVZ_LINK_STEP } from './pvz-link-step/pvz-link-step.config';
import { PVZ_PINCODE_STEP } from './pvz-pincode-step/pvz-pincode-step.config';
import { PVZ_SUBSTITUTE_STEP } from './pvz-substitute-step/pvz-substitute-step.config';
import { SELECT_ACCOUNT_STEP } from './select-account-step/select-account-step.config';
import { TEL_VERIFICATION_STEP } from './tel-verification-step/tel-verification-step.config';

const STEP_DEFINITIONS: AuthStepDefinition[] = [
  ENTER_EMAIL_STEP,
  CONFIRM_EMAIL_STEP,
  SELECT_ACCOUNT_STEP,
  TEL_VERIFICATION_STEP,
  ONBOARDING_STEP,
  PVZ_LINK_STEP,
  PVZ_PINCODE_STEP,
  PVZ_SUBSTITUTE_STEP,
];

export const AUTH_STEPS: AuthStepsRegistry = Object.fromEntries(
  STEP_DEFINITIONS.map((step) => [step.id, step]),
) as AuthStepsRegistry;
